import React, { useEffect, useState } from "react";
import { useT } from "@/i18n/i18n";
import api from "@/lib/api";
import { PageTitle, Panel } from "@/pages/app/kit";
import { Metric } from "@/components/shared";

export default function ImpactPage() {
  const { t, lang } = useT();
  const L = (pl, en) => (lang === "pl" ? pl : en);
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/impact").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="text-mutedtext">…</div>;

  return (
    <div>
      <PageTitle title={t("dashboard.impact")} subtitle={<span className="rounded bg-warnbg px-2 py-0.5 text-xs font-semibold text-warntext">{d.label}</span>} />
      <div className="space-y-6">
        <Panel title={L("Wpływ żywnościowy","Food impact")}>
          <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
            <Metric label="kg registered" value={d.food.kg_registered.toLocaleString()} />
            <Metric label="kg matched" value={d.food.kg_matched.toLocaleString()} />
            <Metric label="kg fresh" value={d.food.kg_fresh.toLocaleString()} />
            <Metric label="kg processed" value={d.food.kg_processed.toLocaleString()} />
          </div>
        </Panel>
        <Panel title={L("Rolnicy i instytucje","Farmers & institutions")}>
          <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
            <Metric label="participating farmers" value={d.farmer.participating_farmers} />
            <Metric label="avg settlement (PLN)" value={d.farmer.avg_settlement.toLocaleString()} />
            <Metric label="institutions served" value={d.institutional.institutions_served} />
            <Metric label="approved matches" value={d.operational.matches} />
          </div>
        </Panel>
        <Panel title={L("Obieg zamknięty","Circular impact")}>
          <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
            <Metric label="redirected from waste (kg)" value={d.food.kg_redirected_from_waste.toLocaleString()} />
            <Metric label="food loss avoided (kg)" value={d.circular.food_loss_avoided.toLocaleString()} />
            <Metric label="recovery records" value={d.circular.recovery_records} />
            <Metric label="crops at risk" value={d.operational.crops_at_risk} />
          </div>
        </Panel>
      </div>
    </div>
  );
}
